function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-05-25 21:10:12 +0200 (Mon, 25 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163262 $
//  Purpose   : component registry react components
// =============================================================================
// ---Third-party imports
import React from 'react';
import { get, iterItems, isObject, isFunction } from 'ldash';
// ---Framework imports
import connect from 'uix/connect';
// ---Globals
export class Registry {
    // access list of components directly
    get components() {
        return this._reg.components;
    }
    constructor(registry){
        // connect to redux store
        _define_property(this, "_connect", (components)=>{
            iterItems(components, (name, comp)=>{
                let ns_name = name;
                if (this._reg.namespace) {
                    ns_name = `${this._reg.namespace}/${name}`;
                }
                // replace component with connected version
                if (isObject(comp)) {
                    let { __render_f, ...descr } = comp;
                    if (isFunction(__render_f)) {
                        this._reg.components[name] = connect(ns_name, descr, __render_f);
                        return; // done
                    }
                }
                this._reg.components[name] = connect(ns_name, comp);
            });
        });
        // get a component by name, if not available we return null
        _define_property(this, "get", (name)=>get(this._reg, `components.${name}`, null));
        // return created react element from component
        _define_property(this, "createElement", (name)=>this.get(name) ? /*#__PURE__*/ React.createElement(this.get(name)) : `Missing ${name}`);
        // register more components
        _define_property(this, "register", (components)=>{
            this._reg.components = {
                ...this._reg.components,
                ...components
            };
            if (this._reg.connect) {
                this._connect(components);
            }
        });
        this._reg = {
            components: {},
            // connect: if true, connect to redux store
            connect: false,
            // namespace: prefix with namespace in redux connect
            namespace: null,
            ...registry
        };
        if (this._reg.connect) {
            this._connect(registry.components);
        }
    }
}
